import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { AlertService } from './alert.service';
import { Router } from '@angular/router';
import { TitleService } from './title.service';
import { Subject } from 'rxjs';
import { StationsService } from './stations.service';
import { VehiclesService } from './vehicles.service';
import { UsersService } from './users.service';


@Injectable({
  providedIn: 'root'
})
export class SessionService {

  /*
    Alert service has been disabled
  */

  public isSigned: boolean = false;
  public role: any = {
    name: '',
    id: -1,
    ability: ''
  };
  public view: any = {
    company: -1,
    user: -1
  };
  public permissionsUpdated: Subject<boolean> = new Subject();
  public loadingPage: Subject<boolean> = new Subject();
  private authorization: string = null;

  constructor(
    private api: RestApiService,
    private alertService: AlertService,
    private router: Router,
    private titleService: TitleService,
    private stationService: StationsService,
    private vehicleService: VehiclesService,
    private userService: UsersService
  ) { }

  private encryptLoginCredentials(username: string, password: string): string {
    return btoa(username + ':' + password);
  }

  private setEmptyRole(): void {
    this.role = {
      name: '',
      id: -1,
      ability: ''
    }
  }

  public updatePermissions(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.get(`/MI_Galago/WCF_MI_Galago/REST/vop/account/permissions`, {}, false).then((permissions) => {

        console.log("permissions", permissions)

        // permissions.permissions = ['admin']
        // if (permissions.permissions.length === 1) {
        //   if(permissions.permissions[0] === "")
        //   {
        //     this.role.ability = 'admin';
        //   }
        // }
        permissions.permissions.forEach((permission) => {
          console.log("permission", permission)
          if (permission === `super_admin`) {
            this.role.ability = `super-admin`;
            this.vehicleService.pageSize = 24;
            this.userService.pageSize = 24;
            this.stationService.pageSize = 24;
          }

          if (permission === `admin`) {
            this.role.ability = `admin`;
            this.vehicleService.pageSize = 6;
            this.userService.pageSize = 8;
            this.stationService.pageSize = 6;
          }
        });
        if (permissions.society !== null) {
          this.role.id = permissions.society.Id;
          this.role.name = permissions.society.Name;
        }

        /////////////////////////Test User//////////////////////////////
        console.log("role", this.role)

        if (permissions.permissions.length === 0) {
          this.role.ability = `user`;
          this.vehicleService.pageSize = 6;
          this.userService.pageSize = 8;
          this.stationService.pageSize = 6;
        }
        ////////////////////////////////////////////////////////////////////

        resolve(this.role);
      })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieveSession(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.authorization = localStorage.getItem('_VOP_Session');
      if (this.authorization != null) {
        this.api.setAuthorization('Basic ' + this.authorization);
        this.api.vget('/MI_Geo/WCF_MI_Geo/REST/Login', {}, false).then((res) => {
          if (res.status === 200) {
            sessionStorage.clear();
            this.isSigned = true;
            this.updatePermissions().then(() => {
              resolve(true);
            });
            // this.alertService.initializeService();
          } else {
            localStorage.removeItem('_VOP_Session');
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    });
  }

  public login(username: string, password: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.authorization = this.encryptLoginCredentials(username, password);
      this.api.setAuthorization('Basic ' + this.authorization);

      // this.loadingPage.next(true);
      // this.isSigned = true;
      // this.router.navigate(['/user/society/list']);
      // return

      this.api.vget('/MI_Geo/WCF_MI_Geo/REST/Login', {}, true).then((res) => {
        console.log(res)
        if (res.status === 200) {
          this.loadingPage.next(true);
          this.isSigned = true;
          sessionStorage.clear()
          localStorage.setItem('_VOP_Session', this.authorization);
          // this.alertService.initializeService();
          this.updatePermissions().then(() => {
            // if(this.role.ability === "")
            // {
            // this.role.ability = 'admin'
            // }
            console.log(this.role)

            if (this.role.ability === 'super-admin') {
              this.router.navigate(['/user/society/list']);
            }
            else if (this.role.ability === 'admin') {
              this.router.navigateByUrl(`/`);

            } else if (this.role.ability === 'user') {
              this.logout();
              this.alertService.error(`Vous n'êtes pas autorisé à consulter l'espace adhérent.`);


              // this.router.navigate(['user/me']);
              // this.router.navigate(['/user/society/list']);
            }
            else {
              this.logout();
              this.alertService.error(`Vous n'êtes pas autorisé à consulter l'espace adhérent.`);
            }

            this.loadingPage.next(false);
          }).catch(() => {
            this.logout();
            this.alertService.error(`Probleme lors de la recuperation de vos permission...`);
          });
        } else {
          this.alertService.error('Les identifiants sont incorrects.');
        }
      });
    });
  }

  public logout(): void {
    // this.alertService.killService();
    localStorage.clear();
    this.authorization = null;
    this.isSigned = false;
    this.setEmptyRole();
    this.api.unsetHeader('Authorization');
    this.titleService.setNotificationCount(0);
    this.router.navigateByUrl(`/login`);
  }

  public checkTokenValidity(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api.vget('/WS/INTERFACE/OAUTH2/token-validity', {}, false).then((res) => {
        console.log(res)
        if (res.status === 200) {
          resolve(true);
        } else {
          // this.logout();
          reject(false);
        }
      });
    });
  }

  public recoveryPassword(token, newPassword): Promise<boolean> {
    // this.api.setHeader("Authorization", 'Bearer ' + token)

    return this.api.vpostBody('/MI_Geo/WCF_MI_Geo/REST/new-password', {
      "newPassword": newPassword,
    }, token).then((res) => {
      if (res.status === 200) {
        this.alertService.alert('Votre mot de passe a été modifié avec succès.');
        // this.router.navigateByUrl(`/login`);
        return true
      } else {
        this.alertService.error('Le token est invalide.');
        return false
      }
    });
  }
}
